import { mapTargetBySelectors } from '@/features/shared/HOCs/withGTM';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';

enum Selectors {
  // Target
  CTA = '.gtm-card-carousel-cta',
  Card = '.swiper-slide',
  // Container
  HeadlineCTA = '.swiper-slide-active .gtm-headline',
  HeadlineCard = '.gtm-tab-title',
  CardContainer = '.gtm-card-carousel-card',
}

export const mapTarget = mapTargetBySelectors([Selectors.CTA, Selectors.Card]);

// If we click a card scroll event should NOT be triggered EVEN if it scrolls.
let isScrollPushPrevented = false;
const preventScrollPush = () => {
  isScrollPushPrevented = true;

  setTimeout(() => {
    isScrollPushPrevented = false;
  });
};

export const onDatalayer = ({ componentRef, target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }

  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;

  const isCTA = target?.classList.contains(Selectors.CTA.replace('.', ''));
  const isCard = target?.classList.contains(Selectors.Card.replace('.', ''));

  if (isCard) {
    const documentHeadline = target?.querySelector(Selectors.HeadlineCard)?.textContent || '';
    preventScrollPush();

    return {
      event: 'clickCard',
      eventCategory: 'Card Carousel',
      ...(!!documentHeadline && { documentHeadline }),
      ...(variantName && { variant_name: variantName }),
    };
  }

  if (isCTA) {
    const documentHeadline =
      componentRef?.current?.querySelector(Selectors.HeadlineCTA)?.textContent ||
      target?.closest(Selectors.CardContainer)?.querySelector(Selectors.HeadlineCard) ||
      '';
    const href = target?.href || '';

    return {
      event: 'clickCTA',
      eventCategory: 'Card Carousel',
      ...(!!documentHeadline && { documentHeadline }),
      href,
      ...(variantName && { variant_name: variantName }),
    };
  }

  return undefined;
};

export const onDatalayerScroll = ({ target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }
  if (isScrollPushPrevented) {
    return undefined;
  }

  const variantName = target?.variantName;

  return {
    event: 'scrollCarousel',
    eventCategory: 'Card Carousel',
    ...(variantName && { variant_name: variantName }),
  };
};
